import React, { useState } from "react";
import { adminMemoryService } from "../../services/admin-memory.service";
import { useToast } from "../../context/ToastContext";
import "../../styles/clients.css";

interface Props {
    onClose: () => void;
    onCreated: () => void;
}

export default function CreateAdminKnowledgeModal({ onClose, onCreated }: Props) {
    const { showToast } = useToast();
    const [question, setQuestion] = useState("");
    const [answer, setAnswer] = useState("");
    const [category, setCategory] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!question.trim()) { setError("Question is required."); return; }
        if (!answer.trim()) { setError("Answer is required."); return; }

        setError("");
        setLoading(true);

        try {
            const payload: { question: string; answer: string; category?: string } = {
                question: question.trim(),
                answer: answer.trim(),
            };
            if (category.trim()) payload.category = category.trim();
            await adminMemoryService.create(payload);
            showToast("Global knowledge entry created successfully.");
            onCreated();
        } catch (err: any) {
            const msg = err.response?.data?.message || err.response?.data?.msg || "Failed to create entry.";
            setError(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                <h2>Add Global Knowledge</h2>
                <p className="modal-subtitle">Create a Q&A entry visible to all clients</p>

                <form className="modal-form" onSubmit={handleSubmit}>
                    {error && <div className="modal-error">{error}</div>}

                    <div className="modal-field">
                        <label htmlFor="admin-kb-question">Question *</label>
                        <textarea
                            id="admin-kb-question"
                            value={question}
                            onChange={(e) => setQuestion(e.target.value)}
                            placeholder="What question should the chatbot answer?"
                            autoFocus
                        />
                    </div>

                    <div className="modal-field">
                        <label htmlFor="admin-kb-answer">Answer *</label>
                        <textarea
                            id="admin-kb-answer"
                            value={answer}
                            onChange={(e) => setAnswer(e.target.value)}
                            placeholder="The answer the chatbot should provide"
                        />
                    </div>

                    <div className="modal-field">
                        <label htmlFor="admin-kb-category">Category</label>
                        <input
                            id="admin-kb-category"
                            type="text"
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            placeholder="e.g. faq, product, policy"
                        />
                    </div>

                    <div className="modal-actions">
                        <button type="button" className="btn-modal-cancel" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="btn-modal-submit" disabled={loading}>
                            {loading ? "Creating..." : "Create"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
